import React from 'react';
import AutoplayCarousel from '@/components/Common/AutoplayCarousel';
import { EXISTING_BRANDS_FEATURED_IN_CONTENT } from '@/shared/constants/existing-brands';
import './index.less';

const FeaturedIn = () => {
  return (
    <div className="featured-in">
      <AutoplayCarousel
        content={EXISTING_BRANDS_FEATURED_IN_CONTENT}
        style={{ gap: '48px' }}
        containerStyle={{ width: '100%', height: '64px', display: 'flex', alignItems: 'center' }}
        priority={true}
        speed="slow"
      />
    </div>
  );
};

export default FeaturedIn;
